/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CatalogOperationRequest {
  /**
  * Which catalog backend to route to (\"default\" for Polaris/Iceberg, \"backup\" for Eon Backup via Glue)
  */
  'catalogName'?: CatalogOperationRequestCatalogNameEnum;
  /**
  * HTTP method to forward to the catalog service (only read operations allowed)
  */
  'method'?: CatalogOperationRequestMethodEnum;
  /**
  * Catalog path to forward (e.g., \"/v1/namespaces\", \"/v1/namespaces/myns/tables/mytable\"). Must start with \"/v1/\". Required when catalogName is \"default\". 
  */
  'path'?: string;
  /**
  * AWS Glue action name (e.g., \"GetDatabases\", \"GetTables\", \"GetTable\", \"GetDatabase\"). Required when catalogName is \"backup\". 
  */
  'action'?: string | null;
  /**
  * Opaque request body. For \"default\" catalog: Iceberg body (POST/PATCH/DELETE). For \"backup\" catalog: raw AWS Glue request parameters. 
  */
  'body'?: any | null;
  /**
  * Query parameters to forward as key-value pairs (used by \"default\" catalog)
  */
  'queryParams'?: { [key: string]: string; } | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "catalogName",
      "baseName": "catalogName",
      "type": "CatalogOperationRequestCatalogNameEnum",
      "format": ""
    },
    {
      "name": "method",
      "baseName": "method",
      "type": "CatalogOperationRequestMethodEnum",
      "format": ""
    },
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "action",
      "baseName": "action",
      "type": "string",
      "format": ""
    },
    {
      "name": "body",
      "baseName": "body",
      "type": "any",
      "format": ""
    },
    {
      "name": "queryParams",
      "baseName": "queryParams",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CatalogOperationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum CatalogOperationRequestCatalogNameEnum {
  Default = 'default',
  Backup = 'backup'
}
export enum CatalogOperationRequestMethodEnum {
  Get = 'GET',
  Head = 'HEAD'
}

